import { render, staticRenderFns } from "./dialog-add-asset.vue?vue&type=template&id=2b6c03b1&scoped=true&"
import script from "./dialog-add-asset.vue?vue&type=script&lang=js&"
export * from "./dialog-add-asset.vue?vue&type=script&lang=js&"
import style0 from "./dialog-add-asset.vue?vue&type=style&index=0&id=2b6c03b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6c03b1",
  null
  
)

export default component.exports